import type { StarsDropDownProps as Props } from '@ps/web-shared-components';
import { StarsDropDown } from '@ps/web-shared-components';
import React from 'react';

import useDisableField from '../../../../hooks/useDisableField';

import { labelContent, root } from './RMFDropDown.scss';

const RMFDropDown: React.FC<Props> = ({ id, disabled, ...props }) => {
  const disableField = useDisableField();

  return (
    <div className={root}>
      <StarsDropDown
        id={id}
        disabled={disabled || disableField(id)}
        labelClassName={labelContent}
        {...props}
      />
    </div>
  );
};
export default RMFDropDown;
